import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const ProductionFloorIcon = ({
  width = 20,
  height = 16,
  color,
}: {
  width?: number;
  height?: number;
  color?: string;
}) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentColor = color ?? token.colorText;

  return (
    <svg width={width} height={height} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.3613 6.88976V6.90348V15.5294H0.120483C0.120483 15.5294 0 6.65022 0 2.19844C0 2.05281 0.0417195 1.91005 0.120483 1.78617C0.199247 1.66229 0.311944 1.56218 0.445945 1.49705C0.579946 1.43192 0.729958 1.40435 0.879171 1.41743C1.02838 1.43051 1.1709 1.48372 1.29076 1.5711L6.35034 3.37553L6.45378 2.19844C6.45378 2.05281 6.4955 1.91005 6.57427 1.78617C6.65303 1.66229 6.76573 1.56218 6.89973 1.49705C7.03373 1.43192 7.18374 1.40435 7.33295 1.41743C7.48217 1.43051 7.62468 1.48372 7.74454 1.5711L12.0596 2.82353L12.3862 1.34682C12.4427 0.973706 12.6349 0.632633 12.928 0.385516C13.221 0.138398 13.5956 0.00161772 13.9835 2.96376e-06H17.4242C17.8139 -0.000731293 18.1909 0.134988 18.486 0.382317C18.7812 0.629646 18.9749 0.97204 19.0316 1.34682L19.3613 6.79272C19.3618 6.79761 19.3618 6.80253 19.3613 6.80742V6.84761V6.88976Z"
        fill={currentColor}
        fillOpacity="0.85"
      />
    </svg>
  );
};

export default ProductionFloorIcon;
